import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Money } from '../../../../Money';
import cn from 'classnames';
import { useTheme } from '../../../../theme';
import { Money as MoneyType } from '../../../../types';

interface Props {
	className?: string;
	min?: MoneyType;
	total?: MoneyType;
}

const PriceBlock: React.FC<Props> = ({ className, min, total }) => {
	const { BaggageTotalPriceBlock: css } = useTheme('BaggageTotalPriceBlock');
	const { t } = useTranslation('AdditionalBaggage');

	if (total?.amount !== undefined && total?.amount !== null) {
		return (
			<div className={cn(className, css.price__selected)}>
				{t('total')}
				<Money money={total} roundType="ceil" />
			</div>
		);
	} else if (min?.amount !== undefined && min?.amount !== null) {
		return (
			<div className={className}>
				{t('from')}
				<Money money={min} />
			</div>
		);
	}

	return null;
};

export default PriceBlock;
